module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/sec02_pc_7f1dd085f3506d395006b1ef22fe2071.jpg";